import TweetItemCareer from "./TweetItemCareer";

function TweetListCareer({ tweets, handleLike, handleDelete, handleReply, handleDeleteReply, career }) {
  return (
    <div className="space-y-4">
      {tweets.map((t) => (
        <TweetItemCareer
          key={t.id}
          tweet={t}
          career={career}            // <--- PASAR career AQUÍ
          onLike={() => handleLike(t.id, t.likes)}
          onDelete={() => handleDelete(t.id)}
          onReply={(text) => handleReply(t.id, text)}
          onDeleteReply={(replyId) => handleDeleteReply(t.id, replyId)}
        />
      ))}
    </div>
  );
}


export default TweetListCareer;
